module.exports = __webpack_public_path__ + "static/media/Bukune_Logo.2d41db5f.jpg";